module.exports = __webpack_public_path__ + "img/circle-plus_2x.4cb1ba10.png";